import { passCodes } from '../passCodes';
import track12 from '../../../../assets/audio/tracks/track12.mp3';

const hints = [
    {
        text: 'Pořádně si prohlédněte podstavec, je to zde hned dvakrát.',
    },
    {
        text: 'To co v noci vidíme na nebi, ale měsíc to není.',
    },
    {
        text: 'Kódem jsou: hvězdy',
        solution: true,
    },
];
export const step12park = {
    id: 12,
    title: '5. stanoviště',
    taskText: `
        <p>
            Ty jo, těch soch tu ale je. Musíme se podívat na všechny. 
        </p>
        <p>    
            Co to má támhle ten voják nahoře na tom podstavci za obrázky?
        </p>
    `,
    cipher: {
        label: 'Úkol',
        text: 'Co na soše vidíte?',
    },
    catImage: 7,
    audio: track12,
    snowAudio: track12,
    codeInputText: 'Zadejte slovo',
    codeInputPassCodeRegexp: passCodes[7],
    additionalInfo: ' ',
    hints: hints,
    snowHints: hints,
};
